package com.milta.core.localization.translations.de

import com.milta.core.localization.AdminOcrAnalysisStrings

internal val AdminOcrAnalysis = AdminOcrAnalysisStrings(
    loading = "Wird geladen…",
    errorNoConnection = "Server nicht erreichbar — bitte Verbindung prüfen.",
    errorGeneric = "Ein Fehler ist aufgetreten. Bitte später erneut versuchen.",
    emptyStateMessage = "Noch keine Daten.",
    kpiTotalDocumentsLabel = "Analysierte Dokumente",
    kpiCompletedDocumentsLabel = "Vollständige Dokumente",
    kpiCompletedDocumentsSubtitle = "für alle 4 Strategien simuliert",
    kpiTotalRealCostLabel = "Gesamte tatsächliche Kosten",
    kpiTotalInputTokensLabel = "Eingabetoken",
    kpiTotalOutputTokensLabel = "Ausgabetoken",
    breakdownByFileKindLabel = "Aufschlüsselung",
    fileKindImageLabel = "Bilder",
    fileKindPdfLabel = "PDFs",
    fileKindXlsxLabel = "Tabellen",
    flowTitle = "Der vollständige Ablauf, Schritt für Schritt",
    flowYesLabel = "Ja",
    flowNoLabel = "Nein",
    flowStep1Title = "Dokument gesendet",
    flowStep1Subtitle = "Foto, PDF oder Datei, über die App erhalten",
    flowStep2Title = "Eindeutiger Fingerabdruck berechnet",
    flowStep2Subtitle = "Für dieses Dokument wird eine eindeutige Kennung berechnet",
    flowStep2Note = "Falls bereits gesehen: Die lokale Analyse wird nicht wiederholt (die tatsächlichen KI-Kosten werden trotzdem normal gezählt, da es ein echter Upload ist).",
    flowStep3Title = "Dateityp erkannt",
    flowStep3Subtitle = "Der Rest der Analyse unterscheidet sich je nach Typ",
    flowImageBranchTitle = "📷 Wenn es ein Foto ist",
    flowImageStep1Title = "Qualitätsprüfung",
    flowImageStep1Subtitle = "Schärfe, Helligkeit, Auflösung, gut gerahmtes Dokument",
    flowImageStep2Title = "Wenn die Qualität als unzureichend eingestuft wird",
    flowImageStep2Subtitle = "Der Grund wird protokolliert, aber das lokale Lesen wird trotzdem direkt danach versucht",
    flowImageStep3Title = "Schiefstandkorrektur",
    flowImageStep3Subtitle = "Das Bild wird begradigt, wenn eine zuverlässige Neigung erkannt wird",
    flowImageStep4Title = "Lokales Lesen (kostenlos)",
    flowImageStep4Subtitle = "Textlesen ohne KI — Französisch, Niederländisch, Englisch",
    flowImageStep5Title = "Zuverlässigkeitswert",
    flowImageStep5Subtitle = "Wert von 0 bis 100 zur Qualität dieses lokalen Lesens",
    flowPdfBranchTitle = "📄 Wenn es ein PDF ist",
    flowPdfStep1Title = "Nativer Text erkannt?",
    flowPdfStep1Subtitle = "Prüft, ob das PDF bereits nutzbaren digitalen Text enthält",
    flowPdfNote = "Falls gescannt ohne nativen Text: Jede Seite (max. 20) wird als Bild gerendert und lokal erneut gelesen, genau wie ein Foto.",
    flowXlsxBranchTitle = "📊 Wenn es eine Tabelle ist",
    flowXlsxStep1Title = "Spalten identifiziert",
    flowXlsxStep1Subtitle = "Automatische oder KI-gestützte Erkennung der Spalten (Name, Adresse, Telefon…)",
    flowXlsxNote = "Dateistruktur (Zeilen, Spalten, Kopfzeile) lokal analysiert.",
    flowClaudeTitle = "KI-Aufruf (Claude)",
    flowClaudeSubtitle = "Heute wird unabhängig vom obigen Pfad immer ein echter Aufruf gemacht — tatsächlich berechnete Kosten",
    flowSimulationTitle = "🔬 Nachträgliche Simulation (nicht in Produktion)",
    flowSimulationNote = "Sobald die obigen Daten gesammelt wurden, werden 4 alternative Strategien auf denselben Dokumenten erneut durchgespielt, um zu schätzen, was sie anstelle des systematischen KI-Aufrufs gekostet hätten — genau das vergleicht die folgende Tabelle. Keine dieser 4 Strategien wird heute tatsächlich in der Produktion verwendet.",
    flowPersistTitle = "Gespeichert",
    flowPersistSubtitle = "Das tatsächliche Ergebnis und die 4 Simulationen werden gespeichert",
    flowDashboardTitle = "Dashboard",
    flowDashboardSubtitle = "Dieser Bildschirm aggregiert die Ergebnisse nach Strategie",
    tableTitle = "Vergleich möglicher Strategien",
    columnMode = "Strategie",
    columnDocuments = "Dokumente",
    columnClaudeCalls = "KI-Aufrufe",
    columnProjectedCost = "Geschätzte Kosten",
    columnRealCost = "Tatsächliche Kosten",
    columnSavings = "Geschätzte Einsparung",
    modeBaseline = "Aktuelle Strategie",
    modeBaselineDescription = "Die KI wird systematisch für jedes Dokument aufgerufen — das wird heute tatsächlich in der Produktion verwendet.",
    modeMinimal = "Leichte Vorverarbeitung",
    modeMinimalDescription = "Kleine Optimierungen vor dem Senden an die KI, ohne die Entscheidung zu ändern: Die KI wird immer aufgerufen, gleiche Kosten wie die aktuelle Strategie.",
    modeTesseractGate = "Lokales Lesen mit KI-Rückgriff",
    modeTesseractGateDescription = "Ein kostenloses lokales Lesen bewertet zunächst die Qualität des Dokuments; die KI wird nur aufgerufen, wenn dieses Lesen als unzureichend eingestuft wird.",
    modeTesseractOnly = "Nur lokales Lesen",
    modeTesseractOnlyDescription = "Kein KI-Aufruf — nur ein kostenloses lokales Lesen, möglicherweise weniger zuverlässig bei Dokumenten schlechter Qualität.",
)
